import { TeamMemberDeletedDtoModelType } from '../../../models';
import getAppRoot from '../../../utils/getAppRoot';

export default ({ store, userUuid }: TeamMemberDeletedDtoModelType) => () => {
  if (!userUuid) return;

  const rootStore = getAppRoot(store);
  const currentUserUuid = rootStore.account.user?.uuid;

  // If the deleted user is the currently logged-in user, log them out
  if (currentUserUuid && currentUserUuid === userUuid) {
    rootStore.auth.logout();
    return;
  }

  // Otherwise, just remove from team members list
  const teamMemberDtos = rootStore.model.teamMemberDtos;
  for (const [id, member] of teamMemberDtos.entries()) {
    if (member.uuid === userUuid) {
      teamMemberDtos.delete(id);
      break;
    }
  }
};
